export const sygnet = ['160 160', `
  <title>WHAKAARO</title>

`]
